export const sendFlushCommandToIframes = () => {
  const iframes = document.getElementsByTagName('iframe')
  const catalogUrl =
    process.env.REACT_APP_CATALOG_URL || 'https://catalog-stg.medgeo.com'

  for (let i = 0; i < iframes.length; i++) {
    const iframe = iframes[i]
    if (iframe.contentWindow) {
      try {
        if (iframe.src.includes('catalog')) {
          iframe.contentWindow.postMessage(
            { type: 'FLUSH_PERSISTED_STATE' },
            catalogUrl
          )
        } else {
          iframe.contentWindow.postMessage(
            { type: 'FLUSH_PERSISTED_STATE' },
            iframe.src || '*'
          )
        }
      } catch (error) {
        console.error('Error sending message to iframe:', error)
      }
    }
  }
}
